<template>
     <v-row>
    <v-col>
  <v-container fluid>
    <v-row v-if="loader2">
      <v-col class="d-flex flex-row align-center justify-space-around">
        <v-progress-circular indeterminate color="success"/>
      </v-col>
    </v-row>
    <v-row v-if="!loader2">
      <v-col>
        <span>
          <span>Current Register {{getCurrentRegister}}</span>
          <v-card-title>Open Register</v-card-title>
          <v-card-text>
            <span v-if="registers.length===1">Using {{registers.find(x => data.registerId===x.id)?.name}}</span>
            <v-text-field outlined label="Opening Float" v-model="data.openingFloat" type="number"/>
            <v-select v-if="registers.length>1" label="Register" outlined :items="registers" item-text="name" item-value="id" v-model="data.registerId"/>
            <v-textarea outlined label="Notes" v-model="data.openingNotes"/>
          </v-card-text>
          <v-card-actions>
            <v-btn color="success" :loading="loader" :disabled="!canOpen || !!openSessionUuid" @click="openRegister">Open Register</v-btn>
            <v-btn v-if="openSessionUuid && isAllowed('register', 'canCloseAny')" class="ml-2" color="info" @click="$router.push(`/registers/view/${openSessionUuid}`)">View Open Register</v-btn>
            <span v-if="openSessionUuid" class="ml-3 text--secondary">This register already has an open session.</span>
          </v-card-actions>
        </span>
      </v-col>
    </v-row>
  </v-container>
    </v-col>
   </v-row>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from "axios";

export default {
  name: 'Home',
  data () {
    return {
      loader: false,
      loader2: false,

      data: {
        openingFloat: 0,
        registerId: null,
        openingNotes: ''
      },

      registers: []
    }
  },
  computed: {
    ...mapGetters(['getEndpoint', 'getBranch', 'getCurrentRegister', 'isAllowed']),
    // the open session of the register picked above, if it has one
    openSessionUuid(){
      return this.registers.find(x => x.id===this.data.registerId)?.openSessionUuid || null
    },
    canOpen(){
      if(this.data.openingFloat===null || this.data.openingFloat===undefined || this.data.openingFloat==='') return false;
      if(isNaN(this.data.openingFloat)) return false;
      if(this.data.openingFloat<0) return false;
      if(!this.data.registerId) return false;
      return true;
    }
  },
  async mounted(){
    try {
      this.loader2 = true;
      if(!this.getBranch) return
      let res = await axios.get(`${this.getEndpoint}/api/registers/byBranch/${this.getBranch}`)
      this.registers = res.data.data
      this.updateCurrentRegister(res.data.registerUUID)

      if(this.registers.length>0) this.data.registerId = this.registers[0].id

    } finally {
      this.loader2 = false;
    }
  },
  methods: {
    ...mapMutations(['updateCurrentRegister']),
    async openRegister(){
      try{
        this.loader = true;

        let res = await axios.post(`${this.getEndpoint}/api/registers/openRegister`, this.data)
        this.updateCurrentRegister(res.data.registerUUID)

        this.$snack(`Register Opened!`, "success");
      }
      finally {
        this.loader = false;
      }
    }
  }
}
</script>
